import React, { Fragment, useMemo } from 'react';
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid } from '@material-ui/core';
import { FormGridType } from '@sierralabs/forms-core';
import { useDataSourceProps } from '../hooks/form/useDataSourceProps';
import { useFormGridConfig } from '../Form.hooks';
import { useFormContext } from '../FormContext';
export const FormMultiSelect = ({ element, edit, disabled, values, onChange }) => {
    const { grid, row, gridColumns } = useFormGridConfig(element.config);
    const { formValues, setFormValue } = useFormContext();
    const key = element.dataSource || element.key;
    const options = useMemo(() => {
        var _a;
        return (((_a = element.config) === null || _a === void 0 ? void 0 : _a.options) || []).map(o => ['string', 'number', 'boolean'].includes(typeof o)
            ? { value: o, label: o.toString() }
            : o);
    }, [element.config]);
    values = values || (formValues[key] || []);
    const dataSourceProps = useDataSourceProps(element, values);
    return (React.createElement(Grid, { item: true, xs: 12 },
        React.createElement(FormControl, { component: 'fieldset', fullWidth: true },
            React.createElement(FormGroup, { row: row, "aria-label": element.title }, options.map((option, index) => {
                const checkbox = (React.createElement(FormControlLabel, { disabled: edit || disabled, value: option.value, label: option.label, control: React.createElement(Checkbox, { color: 'primary', checked: values === null || values === void 0 ? void 0 : values.includes(option.value), onChange: event => {
                            onChange === null || onChange === void 0 ? void 0 : onChange(event, option);
                            if (event.isPropagationStopped() ||
                                event.isDefaultPrevented()) {
                                return;
                            }
                            if (!Array.isArray(values)) {
                                values = [];
                            }
                            if (values.includes(option.value)) {
                                values = values.filter(item => item !== option.value);
                            }
                            else {
                                values = [...values, option.value];
                            }
                            // filter values to only include values from options
                            values = values.filter(value => {
                                return options.some(option => value === option.value);
                            });
                            setFormValue(key, values, element);
                        } }) }));
                if (grid !== FormGridType.Grid) {
                    return React.createElement(Fragment, { key: index }, checkbox);
                }
                return (React.createElement(Grid, { key: index, item: true, xs: 6, md: (12 / gridColumns) }, checkbox));
            })),
            dataSourceProps.helperText && (React.createElement(FormHelperText, { error: dataSourceProps.error }, dataSourceProps.helperText)))));
};
export default FormMultiSelect;
//# sourceMappingURL=FormMultiSelect.js.map